import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { ReturnUrlService } from '../authentication/return-url.service';
@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private _authService: AuthenticationService,
    private _router: Router,
    private _returnUrlService: ReturnUrlService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const authenticated = this._authService.isAuthenticated();
    if (authenticated) {
      return true;
    }
    // Save the attempted URL for redirecting after login
    this._returnUrlService.saveReturnUrl(state.url);
    // navigate to login page
    this._router.navigate(['/auth/login']);
    return false;
  }
}
